<template>
    <div>
        <slot :filterList="filterList" :categories="categories" :filteredPosts="filteredPosts"></slot>
    </div>
</template>

<script>
import { defineComponent, ref, onMounted } from 'vue';
import { uniq, groupBy } from 'lodash';
import { getBlogs } from '../services/inventory';

export default defineComponent({
    name: 'ArticleListHub',
    props: {
        blogId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const blog = ref(null);

        const categories = ref([]);
        const posts = ref([]);
        const selectedCategory = ref('');
        const filteredPosts = ref([]);
        const DEFAULT = 'Choose Category';

        onMounted(async () => {
            const blogs = await getBlogs();
            //console.log('blogs: ', blogs);
            blog.value = blogs.filter(blog => {
                return blog.id === props.blogId;
            })
            blog.value = blog.value[0];

            if (blog.value) {
                posts.value = blog.value.posts.docs;
                filteredPosts.value = blog.value.posts.docs;

                processPosts(posts.value);
            }
        })

        const processPosts = function(posts) {
            posts.forEach(post => {
                //Url patch
                post.url = "/" + blog.value.slug + "/posts/" + post.slug;

                //Process categories
                if (post.categories) {
                    post.categories.forEach(category => {
                        if (category.title) {
                            categories.value.push(category.title)
                        }
                    })
                }
            })

            categories.value = uniq(categories.value);
            categories.value = [DEFAULT, ...categories.value]

            //console.log("Categories: ", categories.value);
        }

        const filterList = function(event) {
            selectedCategory.value = event.target.value;

            filteredPosts.value = posts.value.filter(post => {
                if (selectedCategory.value == DEFAULT) {
                    return true;
                }

                if (post.categories) {
                    const groupedCategories = groupBy(post.categories, category => category.title);

                    return Object.keys(groupedCategories).includes(selectedCategory.value);
                } else {
                    return false;
                }
            })

            //console.log("Filter List: ", filteredPosts.value);
        }

        return {
            filteredPosts: filteredPosts,
            filterList: filterList,
            categories: categories,
        }
    }
});

</script>


